// extracted by mini-css-extract-plugin
module.exports = {"list":"AddWidgetModal_list__3m1iS","button":"AddWidgetModal_button__2Ba2D","buttonImage":"AddWidgetModal_buttonImage__1JpsD"};